import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=e78e2418"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e78e2418')) {
      api.createRecord('e78e2418', component.options)
    } else {
      api.reload('e78e2418', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=e78e2418", function () {
      api.rerender('e78e2418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/utils/avatar.vue"
export default component.exports